export function messageSlide() {
  $('.p-messageSlide').slick({ //{}を入れる
  });
}
